import React from "react";
import { Radio } from "antd";
import { cn } from "../../utils/cn";

const CommonRadio = ({
    options = [],
    value,
    onChange,
    className,
    optionType = "default", // "default" | "button"
    direction = "horizontal", // "horizontal" | "vertical"
    ...props
}) => {
    return (
        <Radio.Group
            options={options}
            value={value}
            onChange={onChange}
            optionType={optionType}
            {...props}
            className={cn(
                `
                flex
                ${direction === "vertical" ? "flex-col gap-2" : "gap-4"}
                [&_.ant-radio-wrapper:hover_.ant-radio-inner]:border-primary
                [&_.ant-radio-checked_.ant-radio-inner]:!border-primary
                [&_.ant-radio-checked_.ant-radio-inner]:!bg-primary
                `,
                className
            )}
        />
    );
};

export default CommonRadio;
